(function () {
  var section = document.querySelector('[data-section-type="cards-buy"]');
  if (!section) return;

  var sid               = section.dataset.sectionId;
  var minCards          = parseInt(section.dataset.minCards, 10)        || 0;
  var shippingThreshold = parseFloat(section.dataset.shippingThreshold) || 60;
  var shippingFee       = parseFloat(section.dataset.shippingFee)       || 5;
  var form              = section.querySelector('form');
  if (!form) return;

  function el(id) { return document.getElementById(id + '-' + sid); }

  // ── hCaptcha ──────────────────────────────────────────────────────────────
  if (window.Shopify && window.Shopify.captcha) {
    window.Shopify.captcha.protect(form);
  }

  // ── Zahlungsmethode Toggle ────────────────────────────────────────────────
  var paymentSelect = el('cb-payment');
  var paypalWrapper = el('cb-paypal');
  var ibanWrapper   = el('cb-iban');
  var paypalInput   = el('cb-paypal-account');
  var ibanInput     = el('cb-iban-input');

  if (paymentSelect) {
    paymentSelect.addEventListener('change', function () {
      var isPayPal = this.value === 'paypal';
      var isBank   = this.value === 'bank';
      paypalWrapper.style.display = isPayPal ? 'block' : 'none';
      ibanWrapper.style.display   = isBank   ? 'block' : 'none';
      paypalInput.required        = isPayPal;
      ibanInput.required          = isBank;
    });
  }

  // ── Rechner ───────────────────────────────────────────────────────────────
  function parsePriceStr(str) {
    return parseFloat((str + '').replace(',', '.')) || 0;
  }

  function formatEuro(val) {
    var parts = val.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' \u20AC';
  }

  function calculate() {
    var total    = 0;
    var totalQty = 0;

    section.querySelectorAll('.cb-qty').forEach(function (input) {
      var qty    = parseInt(input.value, 10) || 0;
      var price  = parsePriceStr(input.dataset.price);
      var amount = qty * price;

      var blockId = input.id
        .replace('qty-', '')
        .replace('-' + sid, '');

      var ltEl  = document.getElementById('lt-'  + blockId + '-' + sid);
      var hidEl = document.getElementById('hid-' + blockId + '-' + sid);

      if (ltEl)  ltEl.textContent = formatEuro(amount);
      if (hidEl) hidEl.value = qty > 0
        ? qty + ' St\u00FCck = ' + formatEuro(amount)
        : '';

      total    += amount;
      totalQty += qty;
    });

    // Bonus
    var baseTotal = total + (bonusApplied ? bonusAmount : 0);

    // Versand
    var freeShipping = baseTotal >= shippingThreshold;
    var shippingCost = (total > 0 && !freeShipping) ? shippingFee : 0;
    var displayTotal = baseTotal - shippingCost;

    // Versandhinweis
    var shippingNotice = el('cb-shipping-notice');
    var shippingText   = el('cb-shipping-text');
    var shippingLine   = el('cb-shipping-line');
    var shippingAmtEl  = el('cb-shipping-amount');
    var hidShipping    = el('cb-hidden-shipping');

    if (total > 0) {
      if (shippingNotice) shippingNotice.style.display = 'block';
      if (freeShipping) {
        if (shippingText) shippingText.textContent =
          '\u2705 Versandkostenfrei \u2013 wir senden dir nach Pr\u00FCfung ein kostenloses Versandlabel zu.';
        if (shippingLine) shippingLine.style.display = 'none';
        if (hidShipping)  hidShipping.value = 'Versandkostenfrei';
      } else {
        var missing = shippingThreshold - baseTotal;
        if (shippingText) shippingText.textContent =
          '\uD83D\uDCE6 Versandpauschale ' + formatEuro(shippingFee) +
          ' wird vom Auszahlungsbetrag abgezogen. Noch ' +
          formatEuro(missing) + ' bis zum kostenlosen Versand.';
        if (shippingLine)  shippingLine.style.display  = 'block';
        if (shippingAmtEl) shippingAmtEl.textContent   = '\u2212 ' + formatEuro(shippingFee);
        if (hidShipping)   hidShipping.value = 'Versandpauschale \u2212 ' + formatEuro(shippingFee);
      }
    } else {
      if (shippingNotice) shippingNotice.style.display = 'none';
      if (shippingLine)   shippingLine.style.display   = 'none';
    }

    // Gesamtsumme & Counter
    var cardCountEl = el('cb-card-count');
    var totalEl     = el('cb-total');
    var hidTotalEl  = el('cb-hidden-total');
    var hidCountEl  = el('cb-hidden-count');
    var submitBtn   = el('cb-submit');
    var minNotice   = el('cb-min-notice');
    var minCountEl  = el('cb-min-count');

    if (cardCountEl) cardCountEl.textContent = totalQty.toLocaleString('de-DE') + ' Karten';
    if (totalEl)     totalEl.textContent     = formatEuro(displayTotal);
    if (hidTotalEl)  hidTotalEl.value        = formatEuro(displayTotal);
    if (hidCountEl)  hidCountEl.value        = totalQty + ' Karten';

    var meetsMin = totalQty >= minCards;
    if (submitBtn)  submitBtn.disabled      = !meetsMin;
    if (minNotice)  minNotice.style.display = (!meetsMin && totalQty > 0) ? 'block' : 'none';
    if (minCountEl) minCountEl.textContent  = totalQty.toLocaleString('de-DE');
  }

  section.querySelectorAll('.cb-qty').forEach(function (input) {
    input.addEventListener('input', calculate);
  });

  // ── Bonus-Code ────────────────────────────────────────────────────────────
  var bonusApplied  = false;
  var bonusAmount   = 5.00;
  var rawCodes      = (section.dataset.bonusCodes || '').trim();
  var validCodes    = rawCodes.length
    ? rawCodes.split(/\r?\n/).map(function (s) { return s.trim().toUpperCase(); }).filter(Boolean)
    : [];

  var codeInput  = document.getElementById('cb-code-input-'      + sid);
  var codeBtn    = document.getElementById('cb-code-btn-'         + sid);
  var codeReset  = document.getElementById('cb-code-reset-'       + sid);
  var codeMsg    = document.getElementById('cb-code-msg-'         + sid);
  var hiddenCode = document.getElementById('cb-hidden-code-used-' + sid);

  function showCodeMsg(text, isSuccess) {
    codeMsg.textContent   = text;
    codeMsg.className     = 'm-0 t5 cb-code-msg ' + (isSuccess ? 'cb-code-msg--success' : 'cb-code-msg--error');
    codeMsg.style.display = 'block';
  }

  function applyCode() {
    if (!codeInput || !validCodes.length) return;
    var entered = codeInput.value.trim().toUpperCase();

    if (bonusApplied) return;

    if (!entered) {
      showCodeMsg('Bitte einen Code eingeben.', false);
      return;
    }

    if (validCodes.indexOf(entered) !== -1) {
      bonusApplied           = true;
      if (hiddenCode) hiddenCode.value = codeInput.value.trim();
      codeInput.disabled     = true;
      codeBtn.style.display  = 'none';
      if (codeReset) codeReset.style.display = 'block';
      showCodeMsg('+5,00 \u20AC Bonus eingelöst! \u2713', true);
      calculate();
    } else {
      showCodeMsg('Code ungültig.', false);
    }
  }

  function resetCode() {
    bonusApplied           = false;
    codeInput.disabled     = false;
    codeInput.value        = '';
    if (hiddenCode) hiddenCode.value = '';
    codeBtn.style.display  = 'block';
    if (codeReset) codeReset.style.display = 'none';
    codeMsg.style.display  = 'none';
    calculate();
  }

  if (codeBtn)   codeBtn.addEventListener('click', applyCode);
  if (codeReset) codeReset.addEventListener('click', resetCode);
  if (codeInput) codeInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); applyCode(); }
  });

  // ── IBAN-Validierung ──────────────────────────────────────────────────────
  if (ibanInput) {
    ibanInput.addEventListener('input', function () {
      var clean = this.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      this.classList.toggle('field__input--error',
        this.value.length > 0 && !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4,30}$/.test(clean)
      );
    });
  }

  // ── Submit-Validierung ────────────────────────────────────────────────────
  form.addEventListener('submit', function (e) {
    var valid    = true;
    var email    = el('cb-email');
    var agb      = el('cb-agb');
    var totalQty = 0;

    section.querySelectorAll('.cb-qty').forEach(function (input) {
      totalQty += parseInt(input.value, 10) || 0;
    });

    // Mindestmenge
    if (totalQty < minCards) {
      e.preventDefault();
      return;
    }

    // E-Mail
    if (email && (!email.value.includes('@') || !email.value.includes('.'))) {
      email.classList.add('field__input--error');
      valid = false;
    }

    // IBAN
    if (ibanWrapper && ibanWrapper.style.display !== 'none' && ibanInput && ibanInput.value) {
      var clean = ibanInput.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4,30}$/.test(clean)) {
        ibanInput.classList.add('field__input--error');
        valid = false;
      }
    }

    // AGB
    if (agb && !agb.checked) {
      agb.closest('.field__checkbox-wrapper').classList.add('cb-error-text');
      valid = false;
    }

    if (!valid) {
      e.preventDefault();
      alert('Bitte korrigiere die markierten Felder.');
    }
  });

  // AGB-Fehler zurücksetzen sobald angehakt
  var agbEl = el('cb-agb');
  if (agbEl) {
    agbEl.addEventListener('change', function () {
      if (this.checked) {
        this.closest('.field__checkbox-wrapper').classList.remove('cb-error-text');
      }
    });
  }

  calculate();
})();
